module.exports = __webpack_public_path__ + "fonts/Axiforma-Black.48cabd4.ttf";